import * as React from 'react';

import { IStyleConfig, mergeStyles } from '@cian/components';

import { TagsGroup } from './tags_group';
import { TagsInput } from './tags_input';

const style = require('./index.css');

export interface ISearchTagsProps {
  words: string[];
  isModerator: boolean;
  onWordAdded(word: string): void;
  onWordRemoved(word: string): void;
  tagStyle?: IStyleConfig;
  containerStyle?: IStyleConfig;
  placeholder?: string;
}

export const SearchTags = (props: ISearchTagsProps) => {
  return (
    <div {...mergeStyles(style['container'], props.containerStyle)}>
      <TagsInput
        isModerator={props.isModerator}
        onTagInput={(newTagName: string) => props.onWordAdded(newTagName)}
        placeholder={props.placeholder}
      />
      <TagsGroup
        tags={props.words}
        onDeleteClick={(index: number) => props.onWordRemoved(props.words[index])}
        commonTagStyle={props.tagStyle}
        containerStyle={props.containerStyle}
      />
    </div>
  );
};
